import Alert from "./Alert"
import Button from "./Button"
import Heading from "./Heading"
import Input from "./Input"
import Menu from "./Menu"
import Modal from "./Modal"
import NumberInput from "./NumberInput"
import Progress from "./Progress"
import Select from "./Select"
import Tabs from "./Tabs"
import Text from "./Text"
import Textarea from "./Textarea"

export default {
  Alert,
  Button,
  Input,
  NumberInput,
  Textarea,
  Select,
  Heading,
  Text,
  Tabs,
  Progress,
  Menu,
  Modal,
}
